export const config = {
  //apiUrl: window.location.origin,
  //apiUrl:"https://localhost:44339",
  //apiUrl:"https://dev.imeiservice.edotteam.com/imeiservice",
  //apiUrl: "https://casebook.in/imeiservice",
  apiUrl:"https://api.imare.in/imeiservice"
};
  